import React from "react";
import { cancelIcon, dashIcon } from "../../../../Base/SVG";

export default function Create() {
  return (
    <div className="guides">
      <h5>
        <span></span>Invoice creation
      </h5>
      <div className="guides__text">
        <p>
          To create an invoice, click
          <button className="button box">
            {dashIcon} <span>Dashboard</span>
          </button>
        </p>
        <p>
          Click on{" "}
          <a href="#" className="button primary">
            Create a New Request +
          </a>
          at the top of the page.
        </p>
        <p>
          In the window that opens, select the date before which the invoice
          will be available for redemption, the amount of the invoice in $, if
          necessary, add a description of the invoice.
        </p>
        <p>
          Next, click on
          <a href="#" className="button primary">
            Save
          </a>
          to create an invoice, or
          <a href="#" className="button bordered">
            Cancel
          </a>
          to abort the creation of an invoice.
        </p>
        <p>
          Then, in the window that opens, you can copy the link to the invoice,
          as well as send the link to one or more of the proposed social
          networks.
        </p>
        <p>
          After completing all the necessary actions, click on{" "}
          <a href="#" className="button bordered">
            Cancel
          </a>
          to close the modal window and return to the dashboard.
        </p>
        <p>
          All your invoices are displayed in the Invoice History block in the
          dashboard.
        </p>
      </div>
    </div>
  );
}
